import { Dropzone } from 'dropzone';
const axios = require('axios');
const FormData = require('form-data');

import { largeNotification } from "./UIModules/largeNotification";
import { smallNotification } from "./UIModules/smallNotification";
require("bootstrap");

$(document).on('ready turbolinks:load', function(){
  if ($('.dropzone').length > 0) {
    Dropzone.autoDiscover = false;
    let isUploading = false;
    const promises = [];

    new Dropzone("#mydropzone", {
      url: "/asset_files", // URL для создания AssetFile
      paramName: "asset_file[image]", // имя параметра, ожидаемого сервером
      maxFiles: 100,
      maxFilesize: 300, // в МБ
      acceptedFiles: ".zip, .pptx, .xlsx, .png, .jpeg, .jpg, .pdf, .mp4, .tif",
      addRemoveLinks: false,
      dictDefaultMessage: "Drop files here or click to upload.",
      dictFallbackMessage: "Your browser does not support drag&drop.",
      dictInvalidFileType: "Incorrect file format.",
      dictFileTooBig: "The file is big. Max size: {{maxFilesize}} Mb.",
      dictRemoveFile: "Remove",
      createImageThumbnails: false,
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      init: function() {
        this.on("addedfile", file => {
          if (!isUploading) {
            isUploading = true;
            $('#wait-spinner').modal('show');
          }
        });
        this.on("queuecomplete", () => {
          setTimeout(() => {
            isUploading = false;
            $('#wait-spinner').modal('hide');
          }, 2000);
        });
        this.on("success", function(file, response) {
          this.removeFile(file);

          // Добавляем карточку с сохранением оригинального URL в data-атрибуте
          const cardviewList = document.querySelector(".cardview-list");
          if (response && response.length > 0) {
            response.forEach((elem) => {
              const cardItem = document.createElement("div");
              cardItem.classList.add("card-item");
              // Сохраняем оригинальный URL файла
              cardItem.setAttribute("data-file-url", elem.file_url);
              cardItem.innerHTML = `
                <button class="close-popup close" title="Close" aria-label="Close" onClick="removeAddedFile('/asset_files/${elem.asset_file_id}')"></button>
                <div class="card-image">
                  <img src="${elem.preview_url ? elem.preview_url : elem.file_url}" alt="Preview">
                </div>
                <div class="card-content">
                  <div class="cart-title">
                    <b>${elem.title || 'Untitled File'}</b>
                  </div>
                  <div class="card-types">
                    <p>${elem.image_format}</p>
                    <p>${elem.image_size}</p>
                  </div>
                </div>`;
              cardviewList.appendChild(cardItem);
            });
          }
          $('.files-counter b').text($('.cardview-container').find('.card-item').length);
        });
        this.on("error", function(file, error) {
          smallNotification("error", "Error:", (error.errors) ? error.errors : error );
        });
      }
    });

    // При отправке файлов для одобрения берем оригинальные файлы по data-атрибуту
    document.querySelector('.sent-for-approval').addEventListener('click', async () =>  {
      $('#wait-spinner').modal('show');
      const profileName = 'PRX - Waiting Room Uploads';
      const regex = /\[[^\]]*\]/g;

      // Получаем оригинальный URL из data-file-url атрибутов карточек
      const cardItems = document.querySelectorAll('.card-item');
      const fileUrls = [];
      const titles = [];
      cardItems.forEach(card => {
        fileUrls.push(card.getAttribute("data-file-url"));
        const title = card.querySelector('.card-content b').innerText;
        titles.push(title);
      });

      // Собираем метаданные из фильтров (код без изменений)
      const filterValues = [];
      const selectTitleElements = document.querySelectorAll('.select-title');
      selectTitleElements.forEach(selectTitle => {
        const parent = selectTitle.parentElement.parentElement;
        const filboxTitle = parent.querySelector('.filbox-title-default');
        const filboxTitleValue = filboxTitle.value.toLocaleLowerCase();
        const value = selectTitle.innerText.replace(regex, '').trim();
        if (value && value !== filboxTitle.value) {
          filterValues.push({ [filboxTitleValue]: value });
        }
      });
      let metadataValues = filterValues.reduce((acc, obj) => ({ ...acc, ...obj }), {});

      // Для каждого файла получаем BLOB по оригинальному URL
      for (let i = 0; i < cardItems.length; i++) {
        const formData = new FormData();
        const response = await fetch(fileUrls[i]);
        const fileData = await response.blob();
        const fileName = titles[i];
        const metadata = {
          'fields': {
            "brand": metadataValues['brand'] ? [metadataValues['brand']] : [],
            "variants": metadataValues['product variant'] ? [metadataValues['product variant']] : [],
            "digitalMedia": metadataValues['asset category'] ? [metadataValues['asset category']] : [],
            "printMedia": metadataValues['documents/sales tools'] ? [metadataValues['documents/sales tools']] : [],
            "subcategory": metadataValues['flavor'] ? [metadataValues['flavor']] : [],
            "programCampaign": metadataValues['program / campaign'] ? [metadataValues['program / campaign']] : [],
            "size": metadataValues['size'] ? [metadataValues['size']] : [],
            "pOS": metadataValues['pos'] ? [metadataValues['pos']] : [],
            "brandVariant": metadataValues['timing'] ? [metadataValues['timing']] : [],
            "categoryProxOneOnly": metadataValues['videos'] ? [metadataValues['videos']] : [],
            "tradeMarketing": metadataValues['trade marketing'] ? [metadataValues['trade marketing']] : [],
            "eCommerce": metadataValues['ecommerce'] ? [metadataValues['ecommerce']] : [],
          }
        };
        formData.append('profile', profileName);
        formData.append('filename', fileName);
        formData.append('metadata', JSON.stringify(metadata));
        formData.append('file', fileData, fileName);

        promises.push(uploadFile(formData, i));
      }

      promises.push(sendToken());
      await Promise.all(promises);
    });

    async function sendToken(){
      try {
        const response = await fetch('/asset_files/send_for_approval', {
          method: 'PATCH',
          headers: {
            'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content,
            'Content-Type': 'application/json'
          }
        });
        if (response.ok) {
          $('.cardview-list').empty();
          $('.files-counter b').text('0');
          return response;
        } else {
          largeNotification("error", "Error!", "Failed to send files for approval.");
        }
      } catch (error) {
        console.error('Error:', error);
        largeNotification("error", "Error!", "Something went wrong");
      }
    }

    async function uploadFile(formData, number) {
      try {
        const response = await axios.post(
          'https://api.widencollective.com/v2/uploads',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: 'Bearer groove/45247f55be3c03d300ca7f3277b06171',
            },
          }
        );
        $('#wait-spinner').modal('hide');
        largeNotification("success", "Done!", "Files have been send for approval, the Support Team will add them shortly once the review is complete");
        return response;
      } catch (error) {
        $('#wait-spinner').modal('hide');
        largeNotification("error", "Error!", "Something went wrong");
        console.error('Error uploading file:', error);
      }
    }
  }
});
